import platformDefaults from '@/styles/_export.module.scss';
import { IconSet } from './IconSet';
import { convertRemToPx } from '@/composables/useScreenSizes';

// Please consult the README for procedures on how to add new colors to this file

// Splitting out colors declaration so that we can reuse it in other defaults
const colors = {
  Primary: platformDefaults.primary,
  Success: platformDefaults.success,
  Accent: platformDefaults.accent,
  Info: platformDefaults.info,
  Warning: platformDefaults.warning,
  Danger: platformDefaults.danger,

  // nonstandard grays
  White: '#ffffff',
  OffWhite: platformDefaults['off-white'],
  Light: platformDefaults.light,
  LightGray: platformDefaults['light-gray'],
  Gray: platformDefaults.gray,
  DarkGray: platformDefaults['dark-gray'],
  BodyGray: platformDefaults['body-gray'],

  Cyan100: platformDefaults['cyan-100'],
  Cyan600: platformDefaults['cyan-600'],

  Gray100: platformDefaults['gray-100'],
  Gray200: platformDefaults['gray-200'],
  Gray300: platformDefaults['gray-300'],
  Gray400: platformDefaults['gray-400'],
  Gray500: platformDefaults['gray-500'],
  Gray600: platformDefaults['gray-600'],
  Gray700: platformDefaults['gray-700'],
  Gray800: platformDefaults['gray-800'],
  Gray900: platformDefaults['gray-900'],

  Green100: platformDefaults['green-100'],
  Green600: platformDefaults['green-600'],

  Orange100: platformDefaults['orange-100'],
  Orange600: platformDefaults['orange-600'],

  Red100: platformDefaults['red-100'],
  Red600: platformDefaults['red-600'],

  HeatmapPositive: platformDefaults['heatmap-positive'],
  HeatmapNegative: platformDefaults['heatmap-negative'],

  NegativeReturn: platformDefaults['negative-return'],
  BlmGreen: platformDefaults['blm'],
  BlmTulipInnerPetals: platformDefaults['blm-tulip-inner-petals'],
  BlmTulipOuterPetals: platformDefaults['blm-tulip-outer-petals'],
  OutOfSample: platformDefaults['out-of-sample'],
  ActiveReturn: platformDefaults['active-return'],
  Benchmark: platformDefaults.benchmark,
  TrackExposure: platformDefaults['track-exposure'],
  LabDefault: platformDefaults['lab-default'],
  Orange: platformDefaults['orange'],
  PeerGroup: platformDefaults['peer-group'],
  BaseFund: platformDefaults['base-fund'],

  Preview: platformDefaults.accent,

  /**
   * For most of our buttons, we use a marginally darker border color than the background color in order for the buttons
   * to appear 'sharper' (a concept taken from Bootstrap).
   *
   * This border color darkens the background color just a bit.
   */
  BorderOverlay: 'rgba(0, 0, 0, 0.15)',
};

export const ApplicationDefaults = {
  colors,
  pdf: {
    logoImage: '',
    navbarColor: colors.Primary,
    navbarTextColor: colors.White,
    navbarLineColor: colors.Info,
    headerColor: colors.Primary,
    headerLineColor: colors.Info,
    disclaimer: '',
    disclaimerTitle: '',
    disclaimerText: '',
  },
  fonts: {
    regular: platformDefaults.font.replace(/['"]+/g, ''),
    monospace: platformDefaults.monospaceFont.replace(/['"]+/g, ''),
  },
  cornerRadius: convertRemToPx(platformDefaults.cornerRadius),
  iconSet: IconSet.REGULAR,
};
